// extracted by mini-css-extract-plugin
module.exports = {"list":"BlogList_list__5fBIH","description":"BlogList_description__bAkvP","item":"BlogList_item__Fj3jd","itemSingle":"BlogList_itemSingle__JmLSU","more":"BlogList_more__RG3fz"};